import { Card, Badge, Tag, EmptyState } from '../../components/ui';
import { DollarSign } from '../../lib/icons';
import { DEAL_STAGE_TONE } from './deal-format';
import type { CrmDeal } from '../../lib/crm-api';

/**
 * Shared deals list used by the CRM company- and contact-detail pages. The two
 * previously kept an identical copy (DealsTab / DealsSection) differing only in
 * the empty-state description.
 */
export function DealsList({ deals, emptyDescription }: { deals: CrmDeal[]; emptyDescription: string }) {
  if (deals.length === 0) return <EmptyState icon={DollarSign} title="No deals" description={emptyDescription} />;
  return (
    <div className="space-y-2">
      {deals.map((d) => (
        <Card
          key={d.id}
          className="p-3 cursor-pointer hover:bg-surface-muted transition-colors"
          onClick={() => (window.location.hash = `#/crm/deals/${d.id}`)}
        >
          <div className="flex items-center gap-3">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-xs font-mono text-fg-muted">{d.deal_number}</span>
                <span className="text-sm font-medium text-fg truncate">{d.title}</span>
              </div>
              <div className="flex items-center gap-2 mt-1">
                <Tag tone={DEAL_STAGE_TONE[d.stage] ?? 'neutral'} truncate>
                  {d.stage}
                </Tag>
                <Badge>{d.type}</Badge>
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <div className="text-sm font-semibold text-fg">${(d.amount || 0).toLocaleString()}</div>
              <div className="text-[10px] text-fg-faint">{d.currency}</div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
